import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["changeMonth", "components", "componentsProps", "date", "leftArrowButtonText", "maxDate", "minDate", "onChange", "renderDay", "rightArrowButtonText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import PickersCalendarHeader from '../CalendarPicker/PickersCalendarHeader';
import DateRangePickerDay from '../DateRangePickerDay';
import { useDefaultDates, useUtils } from '../internal/pickers/hooks/useUtils';
import PickersCalendar from '../CalendarPicker/PickersCalendar';
import { isWithinRange, isStartOfRange, isEndOfRange } from '../internal/pickers/date-utils';
import { doNothing } from '../internal/pickers/utils';
var onlyDayView = ['day'];

/**
 * @ignore - internal component.
 */
export function DateRangePickerViewMobile(props) {
  var changeMonth = props.changeMonth,
    components = props.components,
    componentsProps = props.componentsProps,
    date = props.date,
    leftArrowButtonText = props.leftArrowButtonText,
    maxDateProp = props.maxDate,
    minDateProp = props.minDate,
    onChange = props.onChange,
    _props$renderDay = props.renderDay,
    _renderDay = _props$renderDay === void 0 ? function (_, dayProps) {
      return /*#__PURE__*/React.createElement(DateRangePickerDay, dayProps);
    } : _props$renderDay,
    rightArrowButtonText = props.rightArrowButtonText,
    other = _objectWithoutProperties(props, _excluded);
  var utils = useUtils();
  var defaultDates = useDefaultDates();
  var minDate = minDateProp !== null && minDateProp !== void 0 ? minDateProp : defaultDates.minDate;
  var maxDate = maxDateProp !== null && maxDateProp !== void 0 ? maxDateProp : defaultDates.maxDate;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PickersCalendarHeader, _extends({
    components: components,
    componentsProps: componentsProps,
    leftArrowButtonText: leftArrowButtonText,
    maxDate: maxDate,
    minDate: minDate,
    onMonthChange: changeMonth,
    openView: "day",
    rightArrowButtonText: rightArrowButtonText,
    views: onlyDayView
  }, other)), /*#__PURE__*/React.createElement(PickersCalendar, _extends({}, other, {
    date: date,
    onChange: onChange,
    onFocusedDayChange: doNothing,
    renderDay: function renderDay(day, _, DayProps) {
      return _renderDay(day, _objectSpread({
        isPreviewing: false,
        isStartOfPreviewing: false,
        isEndOfPreviewing: false,
        isHighlighting: isWithinRange(utils, day, date),
        isStartOfHighlighting: isStartOfRange(utils, day, date),
        isEndOfHighlighting: isEndOfRange(utils, day, date)
      }, DayProps));
    }
  })));
}